module.exports = __webpack_public_path__ + "static/img/r-6.dc11c19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/renovation/r-6.jpg
// module id = MEck
// module chunks = 0